import React from 'react';

const buttonStyle = (active, isAction) => ({
  padding: '0.55rem 0.95rem',
  borderRadius: '9999px',
  border: isAction 
    ? '1px dashed #a5b4fc' 
    : `1px solid ${active ? '#4f46e5' : '#d1d5db'}`,
  background: isAction 
    ? '#f5f3ff' 
    : active ? '#eef2ff' : '#fff',
  color: isAction 
    ? '#6366f1' 
    : active ? '#4338ca' : '#475569',
  fontSize: '0.85rem',
  fontWeight: isAction ? 600 : active ? 700 : 500,
  cursor: 'pointer',
  whiteSpace: 'nowrap',
});

const MypageTargetSwitcher = ({ targets = [], currentTargetId, onChange }) => {
  if (!targets.length) return null;

  return (
    <div
      style={{
        display: 'flex',
        gap: '0.5rem',
        overflowX: 'auto',
        padding: '0.25rem 0 0.5rem',
        marginBottom: '0.75rem',
      }}
    >
      {targets.map((target) => (
        <button
          key={target.id}
          type="button"
          onClick={() => onChange?.(target.id)}
          style={buttonStyle(target.id === currentTargetId, target.isAction)}
        >
          {target.label}
        </button>
      ))}
    </div>
  );
};

export default MypageTargetSwitcher;
